<template>
  <NomenclatureTechnique
    :item="materiel" :disabled="disabled"/>
</template>

<script>
import NomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';

export default {
  name: 'nomenclatureMateriel',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    NomenclatureTechnique,
  },
};
</script>
